<template>
  <div class="detail">
    <!-- popup component -->
    <PopupModal/>
    <Header
      :crrNum="crrNum"
      :photoNum="projectList[prjIdx].photo"
      :showInfo="true"
      :prjName="projectList[prjIdx].name"
    />
    <agile @after-change="showCrrSlide($event)" :dots="false">
      <div
        v-for="n in parseInt(projectList[prjIdx].photo)"
        :id="'photo' + n"
        :class="`slide--${n}`"
        :key="n"
      >
        <img :src="require('../assets/project/' + projectList[prjIdx].name +  '/' + n + '.jpg')">
      </div>
      <template slot="nextButton"></template>
      <template slot="prevButton"></template>
    </agile>
  </div>
</template>

<script>
import { VueAgile } from "vue-agile";
import PopupModal from "./Popup.vue";
import EventBus from "../eventBus.js";

export default {
  props: {
    prjIdx: [Number, String]
  },
  data: function() {
    return {
      crrNum: 1
      // photoArea: ""
    };
  },
  components: {
    agile: VueAgile,
    PopupModal
  },
  created() {
    EventBus.$on("use-eventbus", () => {
      this.$modal.show("popup-modal");
    });
  },
  mounted() {
    this.photos = document.querySelector(".photo-area");
  },
  methods: {
    showCrrSlide(event) {
      this.crrNum = event.currentSlide + 1;
    }
  },
  beforeDestroy() {
    this.crrNum = 1;
  }
};
</script>
